// de translations — extracted mechanically from LanguageContext.jsx (Team Foundation).
// Feature-specific keys belong in src/i18n/extensions/*.js instead.
const de = {
    // Common
    "common.loading": "Laden...",
    "common.save": "Speichern",
    "common.cancel": "Abbrechen",
    "common.delete": "Löschen",
    "common.edit": "Bearbeiten",
    "common.submit": "Absenden",
    "common.back": "Zurück",
    "common.next": "Weiter",
    "common.previous": "Zurück",
    "common.search": "Suchen",
    "common.filter": "Filtern",
    "common.all": "Alle",
    "common.yes": "Ja",
    "common.no": "Nein",
    "common.logout": "Abmelden",
    "common.login": "Anmelden",
    "common.register": "Registrieren",
    
    // Auth
    "auth.welcome": "Willkommen",
    "auth.signIn": "Melden Sie sich bei Ihrem Konto an",
    "auth.email": "E-Mail",
    "auth.password": "Passwort",
    "auth.loginButton": "Anmelden",
    "auth.noAccount": "Kein Konto? Registrieren Sie sich mit einem Einladungslink.",
    "auth.loginSuccess": "Anmeldung erfolgreich",
    "auth.loginFailed": "Anmeldung fehlgeschlagen",
    
    // Navigation
    "nav.dashboard": "Dashboard",
    "nav.releases": "Veröffentlichungen",
    "nav.payouts": "Auszahlungen",
    "nav.support": "Support",
    "nav.analytics": "Statistiken",
    "nav.referrals": "Empfehlungen",
    "nav.subscription": "Abonnement",
    "nav.profile": "Profil",
    
    // Dashboard
    "dashboard.welcome": "Willkommen",
    "dashboard.subtitle": "Verwalten Sie Ihre Musik, verfolgen Sie Ihre Veröffentlichungen und sehen Sie Ihre Einnahmen.",
    "dashboard.totalReleases": "Gesamte Veröffentlichungen",
    "dashboard.totalTracks": "Gesamte Tracks",
    "dashboard.balance": "Aktueller Kontostand",
    "dashboard.withdrawable": "Auszahlbar",
    "dashboard.recentReleases": "Neueste Veröffentlichungen",
    "dashboard.viewAll": "Alle Anzeigen",
    "dashboard.newRelease": "Neue Veröffentlichung",
    "dashboard.newReleaseDesc": "Teilen Sie Ihre Musik mit der Welt",
    "dashboard.requestPayout": "Auszahlung Anfordern",
    "dashboard.noReleases": "Noch keine Veröffentlichungen",
    "dashboard.createFirst": "Erstellen Sie Ihre erste Veröffentlichung.",
    
    // Analytics
    "analytics.title": "Statistiken",
    "analytics.subtitle": "Verfolgen Sie die Leistung Ihrer Veröffentlichungen",
    "analytics.totalStreams": "Gesamte Streams",
    "analytics.listeners": "Hörer",
    "analytics.estimatedEarnings": "Geschätzte Einnahmen",
    "analytics.monthlyGrowth": "Monatliches Wachstum",
    "analytics.streamsChart": "Streams-Diagramm",
    "analytics.platformDistribution": "Plattform-Verteilung",
    "analytics.topTracks": "Top-Titel",
    "analytics.trackName": "Titelname",
    "analytics.streams": "Streams",
    "analytics.comingSoonTitle": "Demnächst Verfügbar",
    "analytics.comingSoonDesc": "Detaillierte Analysen und Einblicke kommen bald. Mit der artist.tools Integration können Sie alle Ihre Plattformdaten an einem Ort verfolgen.",
    "common.comingSoon": "Demnächst",
    
    // Payouts
    "payouts.title": "Verwalten Sie Ihre Einnahmen",
    "payouts.subtitle": "Heben Sie Ihre Musikeinnahmen einfach ab. Fordern Sie eine Auszahlung ab $50 an.",
    "payouts.fastPayment": "Schnelle Zahlung",
    "payouts.secureTransfer": "Sichere Überweisung",
    "payouts.totalBalance": "Gesamtguthaben",
    "payouts.withdrawableBalance": "Auszahlbar",
    "payouts.requestPayout": "Auszahlung Anfordern",
    "payouts.payoutHistory": "Auszahlungsverlauf",
    "payouts.noPayouts": "Noch keine Auszahlungsanfragen",
    "payouts.noPaymentMethod": "Keine Zahlungsmethode",
    "payouts.addMethodDesc": "Fügen Sie eine Zahlungsmethode hinzu, um Ihre Einnahmen abzuheben.",
    "payouts.addMethod": "Zahlungsmethode Hinzufügen",
    "payouts.changeMethodVerification": "E-Mail-Bestätigung erforderlich um Ihre aktuelle Zahlungsmethode zu ändern",
    "payouts.availableBalance": "Verfügbares Guthaben",
    "payouts.pendingBalance": "Ausstehendes Guthaben",
    "payouts.withdrawalHistory": "Abhebungsverlauf",
    "payouts.requestWithdrawal": "Abhebung Anfordern",
    "payouts.minWithdrawal": "Mindestabhebung: $50",
    "payouts.manageEarnings": "Verwalten Sie Ihre Einnahmen",
    "payouts.createRequest": "Auszahlungsanfrage Erstellen",
    "payouts.amount": "Betrag",
    "payouts.accountHolder": "Kontoinhaber",
    "payouts.bankName": "Bankname",
    "payouts.minAmount": "Mindestabhebungsbetrag ist $50",
    "payouts.insufficientBalance": "Unzureichendes Guthaben",
    "payouts.fillRequired": "Bitte füllen Sie alle erforderlichen Felder aus",
    "payouts.requestCreated": "Auszahlungsanfrage erstellt",
    "payouts.requestFailed": "Anfrage fehlgeschlagen",
    "payouts.minNotMet": "Minimum nicht erreicht",
    "payouts.minNotMetMsg": "Sie benötigen mindestens $50 auszahlbares Guthaben für eine Auszahlung.",
    "payouts.statusRequested": "Angefordert",
    "payouts.statusPaid": "Bezahlt",
    "payouts.paymentMethod": "Zahlungsmethode",
    "payouts.bankTransfer": "Banküberweisung",
    "payouts.paypalEmail": "PayPal-E-Mail",
    "payouts.paypalNote": "Geben Sie die mit Ihrem PayPal-Konto verknüpfte E-Mail ein",
    "payouts.fillPaypalRequired": "Bitte geben Sie PayPal-E-Mail und Kontoinhabername ein",
    "payouts.selectCountry": "Wählen Sie Ihr Land",
    "payouts.tabProfile": "Zahlungsprofil",
    "payouts.tabMethod": "Zahlungsmethode",
    "payouts.tabRequests": "Auszahlungsanfragen",
    "payouts.requirements": "Anforderungen für Auszahlung",
    "payouts.completeProfile": "Vervollständigen Sie Ihr Zahlungsprofil (Identität und Adresse)",
    "payouts.addPaymentMethod": "Fügen Sie eine Zahlungsmethode hinzu (Bank oder PayPal)",
    "payouts.verifyPaymentMethod": "Verifizieren Sie Ihre Zahlungsmethode",
    "payouts.profileComplete": "Abgeschlossen",
    "payouts.savedProfile": "Gespeicherte Profilinformationen",
    "payouts.fullName": "Vollständiger Name",
    "payouts.phoneNumber": "Telefon",
    "payouts.location": "Standort",
    "payouts.profileType": "Profiltyp",
    "payouts.individual": "Einzelperson",
    "payouts.business": "Unternehmen / Firma",
    "payouts.edit": "Bearbeiten",
    
    // Support
    "support.title": "Wie können wir helfen?",
    "support.subtitle": "Das EAM Music Team beantwortet gerne Ihre Fragen.",
    "support.responseTime": "Antwort innerhalb 24 Stunden",
    "support.professional": "Professioneller Support",
    
    // Referrals
    "referrals.title": "Empfehlungsprogramm",
    "referrals.subtitle": "Laden Sie Freunde zu EAM Music ein und verdienen Sie 5% Provision.",
    "referrals.commission": "5% Provision",
    "referrals.lifetime": "Lebenslange Einnahmen",
    
    // Statuses
    "status.draft": "Entwurf",
    "status.submitted": "Eingereicht",
    "status.inReview": "In Überprüfung",
    "status.approved": "Genehmigt",
    "status.rejected": "Abgelehnt",
    "status.live": "Live",
    
    // Validation
    "validation.audioRequired": "Audiodatei ist erforderlich",
    "validation.audioFormatWav": "Audiodatei muss im WAV- oder FLAC-Format vorliegen",
    "validation.titleRequired": "Titel ist erforderlich",
    "validation.titleLanguageRequired": "Titelsprache ist erforderlich",
    "validation.primaryArtistRequired": "Mindestens ein Hauptkünstler ist erforderlich",
    "validation.primaryGenreRequired": "Hauptgenre-Auswahl ist erforderlich",
    "validation.explicitRequired": "Inhaltstyp-Auswahl ist erforderlich",
    "validation.coverRequired": "Coverbild ist erforderlich",
    "validation.songwriterRequired": "Mindestens ein Songwriter ist erforderlich",
    "validation.contributorRequired": "Mindestens ein Mitwirkender ist erforderlich",
    "validation.productionTeamRequired": "Mindestens ein Produktionsteam-Mitglied ist erforderlich",
    "validation.platformRequired": "Mindestens eine Plattform muss ausgewählt werden",
    "validation.releaseDateRequired": "Veröffentlichungsdatum ist erforderlich",
    "validation.trackCountRequired": "Mindestens 2 Titel für EP/Album erforderlich",
    "releases.track": "Titel",
    
    // Spotify
    "spotify.title": "Spotify for Artists",
    "spotify.comingSoon": "Demnächst",
    "spotify.description": "Greifen Sie direkt über das EAM-Panel auf Ihr Spotify Artist-Konto zu.",
};

export default de;
